import { render, staticRenderFns } from "./Promedio.vue?vue&type=template&id=9463b4f0"
import script from "./Promedio.vue?vue&type=script&lang=js"
export * from "./Promedio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports